export const setFavicon = () => {
    const favicon = document.getElementById('favicon') as HTMLLinkElement | null;
    const envFavicon = process.env.REACT_APP_FAVICON;
    if (favicon && envFavicon) {
        favicon.href = process.env.PUBLIC_URL + '/' + envFavicon;
    }
};
